import { Copy, Check } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';
import { useToast } from '@/hooks/use-toast';

interface CopyableTextProps {
  text: string | null | undefined;
  className?: string;
}

export function CopyableText({ text, className }: CopyableTextProps) {
  const [hasCopied, setHasCopied] = useState(false);
  const { toast } = useToast();

  // If text is empty/null/undefined, just render as plain text
  if (!text?.trim()) {
    return <span className={className}>{text}</span>;
  }

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setHasCopied(true);
      toast({
        title: 'Copied to clipboard!',
        variant: 'default'
      });
      setTimeout(() => {
        setHasCopied(false);
      }, 2000);
    } catch (_error) {
      toast({
        title: 'Failed to copy',
        description: 'Please try again',
        variant: 'destructive'
      });
    }
  };

  return (
    <div
      className={cn(
        'group relative inline-flex items-center gap-1 cursor-pointer hover:text-foreground/80',
        className
      )}
      onClick={() => {
        void copyToClipboard();
      }}
    >
      <span>{text}</span>
      {hasCopied ? (
        <Check className="h-3.5 w-3.5 text-green-500 opacity-0 group-hover:opacity-100 transition-opacity" />
      ) : (
        <Copy className="h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
      )}
    </div>
  );
}
